import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { SidewallPage } from "./SidewallPage";
import { eqpThemeExtension } from "../../shared/theme";

const Sidewall = () => {
  const baseTheme = useTheme();

  // Create extended theme with EAF colors
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...eqpThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <SidewallPage />
    </ThemeProvider>
  );
};

export default Sidewall;
export { SidewallPage };
